/**
 * Заглушка для разделов ERP, которые ещё не реализованы (UI-1, план 2026-09-25).
 * Маршруты заглушек регистрирует router.js из utils/erp-modules.js (пункты без view).
 */
import { getBasePath } from '../router.js';
import { BRAND } from '../utils/brand.js';
import { findItem } from '../utils/erp-modules.js';

export async function initStub(container) {
  const found  = findItem(getBasePath(location.pathname));
  const module = found?.module;
  const item   = found?.item;
  const wave   = item?.wave || 'В2';
  const near   = module?.nearest;

  container.innerHTML = `
    <div class="stub-view">
      <div class="stub-card">
        <div class="stub-module">${BRAND} · ${module?.label ?? 'ERP'}</div>
        <h2 class="stub-title">${item?.label ?? 'Раздел'}</h2>
        <p class="stub-text">Раздел в разработке, волна ${wave}.</p>
        ${near ? `<p class="stub-hint">Ближайший рабочий экран:
          <a href="${near.path}" data-route="${near.path}">${near.label}</a></p>` : ''}
      </div>
    </div>`;
}
